<template>
  <div>
    <div class="input-group mb-3" v-if="!modifyComponentsNotShown.includes(ticket.estat.nom) &&
      this.checkUserInTicket(this.user, ticket)">
        <AddFiles @updateFiles="childVal => {
          this.addFiles = childVal.files
        }"/>
        <div class="input-group-append">
          <button @click.prevent="save()" class="input-group-text" id="basic-addon2">
            <font-awesome-icon :icon="['fas', 'cloud-upload-alt']"/>
          </button>
        </div>
    </div>
    <FilesPreview v-if="this.files.length > 0" :files="this.files" :ticket_id="this.ticket.id"/>
    <b-form-row v-else>
      <label class="font-weight-bold">No hi han fitxers adjunts</label>
    </b-form-row>
  </div>
</template>

<script>
import AddFiles from '@/components/AddFiles'
import FilesPreview from '@/components/FilesPreview'

export default {
  components: {
    AddFiles,
    FilesPreview
  },
  props: {
    files: {
      required: true,
      type: Array
    }
  },
  computed: {
    ticket () {
      return this.$store.state.ticket
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      // Casos en los que no podemos añadir registros o seguir
      modifyComponentsNotShown: ['closed', 'canceled'],
      addFiles: ''
    }
  },
  methods: {
    save () {
      if (this.isNullOrUndefined(this.files)) {
        this.notifyError('Falta informació', 'El camp fitxer es necessari')
      } else {
        var formData = new FormData()
        formData.append('ticket_id', this.ticket.id)
        formData.append('user', this.user.id)

        for (var i = 0; i < this.addFiles.length; i++) {
          let file = this.addFiles[i]
          formData.append(file.name, file)
        }
        this.$store.dispatch('addFiles', formData)
      }
    }
  }
}
</script>

<style scoped>
</style>
